module.exports = __webpack_public_path__ + "img/mgicon.b2ce2738.svg";